import { render, staticRenderFns } from "./add_asset.vue?vue&type=template&id=151e8422&scoped=true"
import script from "./add_asset.vue?vue&type=script&lang=js"
export * from "./add_asset.vue?vue&type=script&lang=js"
import style0 from "./add_asset.vue?vue&type=style&index=0&id=151e8422&prod&lang=css&scoped=true"
import style1 from "./add_asset.vue?vue&type=style&index=1&id=151e8422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151e8422",
  null
  
)

export default component.exports